// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrialcardCovermymedsV1ModelsResponseModel } from './trialcardCovermymedsV1ModelsResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CmmV1InboundStatusUpdateSuccessResponse {
    'data': TrialcardCovermymedsV1ModelsResponseModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static discriminator = "success" as const;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CmmV1InboundStatusUpdateSuccessResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "TrialcardCovermymedsV1ModelsResponseModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return CmmV1InboundStatusUpdateSuccessResponse.attributeTypeMap;
    }
}
